<ion-card
  button="true"
  (click)="showRequestPromotionalCreditsModal()"
>
  <ion-card-header mode="ios">
    <ion-card-title color="secondary">{{ 'promotional_credits_banner.title' | translate }}</ion-card-title>
    <ion-card-subtitle>{{ 'promotional_credits_banner.subtitle' | translate }}</ion-card-subtitle>
  </ion-card-header>
  <ion-card-content class="ion-text-end">
    <ion-button>{{ 'promotional_credits_banner.request' | translate }}</ion-button>
  </ion-card-content>
</ion-card>
